import _ from 'lodash'
import { Skeleton } from '@/components/ui/skeleton'

export function TierCardSkeleton() {
	return (
		<div className='flex w-full flex-col overflow-hidden rounded-2xl border border-border bg-card'>
			<div className='flex h-[420px] items-center justify-center bg-background'>
				<Skeleton className='h-[380px] w-[380px] rounded-full bg-muted/40' />
			</div>
			<div className='flex flex-col items-center gap-2 px-5 pb-4 pt-4'>
				<Skeleton className='h-7 w-32 bg-muted/40' />
				<Skeleton className='h-5 w-40 bg-muted/40' />
			</div>
			<div className='mx-5 border-t border-border' />
			<div className='flex flex-col gap-4 px-5 py-4'>
				{_.times(4, (index) => (
					<div key={index} className='flex items-center justify-between gap-3'>
						<Skeleton className='h-5 w-28 bg-muted/40' />
						<Skeleton className='h-5 w-16 bg-muted/40' />
					</div>
				))}
			</div>
		</div>
	)
}
